import type { TourDefinition } from "../types";

/**
 * Tour for /app/settings. Walks through the three settings tabs:
 * billing, members, and regions.
 */
export const workspaceSettingsTour: TourDefinition = {
  id: "workspace-settings",
  label: "Workspace Settings",
  description: "Plan, team & regions",
  routeMatch: /^\/app\/settings\/?$/,
  path: "/app/settings",
  estimatedSeconds: 50,
  steps: [
    {
      target: "body",
      placement: "center",
      title: "Workspace Settings",
      body: "Everything that scopes to this workspace lives here — your plan, teammates, and unlocked regions.",
    },
    {
      target: '[data-tour="settings.tabs"]',
      placement: "bottom",
      title: "Three tabs",
      body: "Plan & Billing shows your credit balance and subscription. Seats & Members lets you invite teammates. Regions shows which market regions are unlocked.",
      showIf: () => !!document.querySelector('[data-tour="settings.tabs"]'),
    },
    {
      target: '[data-tour="settings.invite"]',
      placement: "top",
      title: "Invite your team",
      body: "Workspace admins can invite teammates by email. They'll get a link to join this workspace once they sign in or sign up.",
      showIf: () => !!document.querySelector('[data-tour="settings.invite"]'),
    },
  ],
};
